import { ORIGIN, SERVER_URL } from "../config";
import Swal from "sweetalert2";
import axiosService, { defaultHeaders } from "./axios-service";

export const getOTP = async (client_id) => {
  const data = { client_id };
  // console.log(data);
  try {
    const response = await fetch(`${SERVER_URL}/sales/incentive/generate-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...defaultHeaders,
      },
      mode: "cors",
      body: JSON.stringify(data),
    });
    if (response.status === 200) {
      let result = await response.json();
      if (result.error === "nil") {
      } else {
        Swal.fire({
          icon: "error",
          text: result.error,
          timer: 1600,
        });
      }
      return result;
    } else {
      try {
        let result = await response.json();
        Swal.fire({
          icon: "error",
          text: result.message || result.error,
          timer: 1600,
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          text: "Something went wrong!, Please contact support.",
          timer: 1600,
        });
      }
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      text: error.message,
      timer: 1600,
    });
  }
};

export const loginotp = async (client_id, otpi, fcmToken) => {
  var otp = JSON.parse(otpi);
  const data = {
    client_id: client_id,
    otp: otp,
    token: fcmToken,
  };
  try {
    const response = await fetch(`${SERVER_URL}/sales/incentive/verify-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...defaultHeaders,
      },
      mode: "cors",
      body: JSON.stringify(data),
    });
    if (response.status === 200) {
      let result = await response.json();
      localStorage.setItem(
        "staff_role",
        result.staff_role || "no staff role found"
      );
      if (result.error === "nil" || !result.error) {
        Swal.fire({
          icon: "success",
          text: "You are now logged in.",
          timer: 1600,
        });
      } else {
        Swal.fire({
          icon: "error",
          text: result.error,
          timer: 1600,
        });
      }
      return result;
    } else {
      let result = await response.json();
      Swal.fire({
        icon: "error",
        text: result.message || result.error,
        timer: 1600,
      });
    }
  } catch (error) {
    console.error(error);
    Swal.fire({
      icon: "error",
      text: error.message || "Something went wrong!",
      timer: 1600,
    });
    // toast.error('Something Went Wrong!');
  }
};

export const captchaVerify = async (token) => {
  const data = {
    token,
  };
  try {
    const response = await axiosService.post(
      `/sales/incentive/captcha_verify`,
      data
    );
    if (response.status === 200) {
      return response.data;
    } else {
      let result = response;
      Swal.fire({
        icon: "error",
        text: result.message || result.error,
        timer: 1600,
      });
    }
  } catch (error) {
    console.error(error);
    // toast.error('Something Went Wrong!');
  }
};

export const logoutApi = async () => {
  try {
    const response = await axiosService.get(`/sales/incentive/logout`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
